// extracted by mini-css-extract-plugin
export var macHeroCompass = "index-module--mac-hero-compass--af422";
export var macHeroContent = "index-module--mac-hero-content--c062b";
export var macHeroH1 = "index-module--mac-hero-h1--ca017";
export var macHeroH2 = "index-module--mac-hero-h2--9d8c5";
export var macHeroImg = "index-module--mac-hero-img--88e00";